// export const appConfigConstant = {
//     MASTER_DATA_API_BASE_URL: 'https://gspt-master-data-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1/masterdata',
//     WITHOUT_MASTER_DATA_API_BASE_URL: "https://gspt-master-data-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1",
//     DEMAND_STRATEGY_API_BASE_URL: 'https://gspt-demand-strategy-service-api.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1/masterdata',
//     CROP_CYCLE_API_BASE_URL: 'https://gspt-crop-cycle-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1/masterdata',
//     WITHOUT_CROP_CYCLE_API_BASE_URL: 'https://gspt-crop-cycle-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/api',
//     DEMAND_ACTUALS_API_BASE_URL: 'https://gspt-demand-actuals-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com',
//     NOTIFICATION_API_BASE_URL: 'https://gspt-notification-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com',
//     ALLOCATION_SERVICE_BASE_URL: 'https://gspt-allocation-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1/allocations',
//     ALLOCATION_SERVICE_BASE_URL_V1: 'https://gspt-allocation-service.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/gspt/api/v1',
//     LOGIN_REDIRECT_URL: process.env?.REACT_APP_OKTA_BASE_EXTERNAL_REDIRECT_URL || 'https://aghub.qa.pepsico.com'
// }

// ENABLE THIS FOR DEV, QA and PREPROD
// export const appConfigConstant = {
//   MASTER_DATA_API_BASE_URL:
//     process.env?.REACT_APP_API_MASTER_DATA_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-master-data-service/v1/gspt/api/v1/masterdata',

//   WITHOUT_MASTER_DATA_API_BASE_URL:
//     process.env?.REACT_APP_API_WITHOUT_MASTER_DATA_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-master-data-service/v1/gspt/api/v1',

//   DEMAND_STRATEGY_API_BASE_URL:
//     process.env?.REACT_APP_API_DEMAND_STRATEGY_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-demand-strategy-service/v1/gspt/api/v1/masterdata',

//   CROP_CYCLE_API_BASE_URL:
//     process.env?.REACT_APP_API_CROP_CYCLE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-crop-cycle-service/v1/gspt/api/v1/masterdata',

//   WITHOUT_CROP_CYCLE_API_BASE_URL:
//     process.env?.REACT_APP_API_WITHOUT_CROP_CYCLE_API_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-crop-cycle-service/v1/api',

//   DEMAND_ACTUALS_API_BASE_URL:
//     process.env?.REACT_APP_API_DEMAND_ACTUALS_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-demand-actual-service/v1',

//   NOTIFICATION_API_BASE_URL:
//     process.env?.REACT_APP_API_NOTIFICATION_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-notification-service/v1/cgf/ravitest/v1',

//   LOGIN_REDIRECT_URL:
//     process.env?.REACT_APP_OKTA_BASE_EXTERNAL_REDIRECT_URL || 'https://aghub.dev.pepsico.com',

//   ALLOCATION_SERVICE_BASE_URL:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service/v1/gspt/api/v1/allocations',

//   ALLOCATION_SERVICE_BASE_URL_V1:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V1 ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service/v1/gspt/api/v1',

//   SUPPLY_ACTUALS_SERVICE_BASE_URL:
//     process.env?.REACT_APP_SUPPLY_ACTUALS_SERVICE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service/v1/gspt/api/v1/supply-actuals',

//   LANDING_NOTIFICATIONS_BASE_URL:
//     process.env?.REACT_APP_LANDING_NOTIFICATIONS_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-notification-service/v1/gspt/api/v1',

//   ALLOCATION_SERVICE_BASE_URL_V2:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V2 ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service/v1/gspt/api/v2/allocations',
// }

// ENABLE THIS FOR SIT Environment
// export const appConfigConstant = {
//   MASTER_DATA_API_BASE_URL:
//     process.env?.REACT_APP_API_MASTER_DATA_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-master-data-service-sit/v1/gspt/api/v1/masterdata',

//   WITHOUT_MASTER_DATA_API_BASE_URL:
//     process.env?.REACT_APP_API_WITHOUT_MASTER_DATA_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-master-data-service-sit/v1/gspt/api/v1',

//   DEMAND_STRATEGY_API_BASE_URL:
//     process.env?.REACT_APP_API_DEMAND_STRATEGY_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-demand-strategy-service-sit/v1/gspt/api/v1/masterdata',

//   CROP_CYCLE_API_BASE_URL:
//     process.env?.REACT_APP_API_CROP_CYCLE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-crop-cycle-service-sit/v1/gspt/api/v1/masterdata',

//   WITHOUT_CROP_CYCLE_API_BASE_URL:
//     process.env?.REACT_APP_API_WITHOUT_CROP_CYCLE_API_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-crop-cycle-service-sit/v1/api',

//   DEMAND_ACTUALS_API_BASE_URL:
//     process.env?.REACT_APP_API_DEMAND_ACTUALS_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-demand-actual-service-sit/v1',

//   NOTIFICATION_API_BASE_URL:
//     process.env?.REACT_APP_API_NOTIFICATION_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-notification-service-sit/v1/cgf/ravitest/v1',

//   LOGIN_REDIRECT_URL:
//     process.env?.REACT_APP_OKTA_BASE_EXTERNAL_REDIRECT_URL || 'https://aghub.dev.pepsico.com',

//   ALLOCATION_SERVICE_BASE_URL:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service-sit/v1/gspt/api/v1/allocations',

//   ALLOCATION_SERVICE_BASE_URL_V1:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V1 ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service-sit/v1/gspt/api/v1',

//   SUPPLY_ACTUALS_SERVICE_BASE_URL:
//     process.env?.REACT_APP_SUPPLY_ACTUALS_SERVICE_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service-sit/v1/gspt/api/v1/supply-actuals',

//   LANDING_NOTIFICATIONS_BASE_URL:
//     process.env?.REACT_APP_LANDING_NOTIFICATIONS_BASE_URL ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-notification-service-sit/v1/gspt/api/v1',

//   ALLOCATION_SERVICE_BASE_URL_V2:
//     process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V2 ||
//     'https://apim-na.dev.mypepsico.com/cgf/gspt-allocation-supply-service-sit/v1/gspt/api/v2/allocations',
// }

export const appConfigConstant = {
  MASTER_DATA_API_BASE_URL:  window._env_?.REACT_APP_API_MASTER_DATA_BASE_URL || process.env?.REACT_APP_API_MASTER_DATA_BASE_URL,
  WITHOUT_MASTER_DATA_API_BASE_URL:  window._env_?.REACT_APP_API_WITHOUT_MASTER_DATA_BASE_URL || process.env?.REACT_APP_API_WITHOUT_MASTER_DATA_BASE_URL,
  DEMAND_STRATEGY_API_BASE_URL:  window._env_?.REACT_APP_API_DEMAND_STRATEGY_BASE_URL || process.env?.REACT_APP_API_DEMAND_STRATEGY_BASE_URL,
  CROP_CYCLE_API_BASE_URL:  window._env_?.REACT_APP_API_CROP_CYCLE_BASE_URL || process.env?.REACT_APP_API_CROP_CYCLE_BASE_URL,
  WITHOUT_CROP_CYCLE_API_BASE_URL:  window._env_?.REACT_APP_API_WITHOUT_CROP_CYCLE_API_BASE_URL || process.env?.REACT_APP_API_WITHOUT_CROP_CYCLE_API_BASE_URL,
  DEMAND_ACTUALS_API_BASE_URL:  window._env_?.REACT_APP_API_DEMAND_ACTUALS_BASE_URL || process.env?.REACT_APP_API_DEMAND_ACTUALS_BASE_URL,
  NOTIFICATION_API_BASE_URL:  window._env_?.REACT_APP_API_NOTIFICATION_BASE_URL || process.env?.REACT_APP_API_NOTIFICATION_BASE_URL,
  APP_CLIENT_ID:  window._env_?.REACT_APP_GSPT_CLIENT_ID || process.env?.REACT_APP_GSPT_CLIENT_ID,
  LOGIN_REDIRECT_URL:  window._env_?.REACT_APP_OKTA_LOGOUT_REDIRECT_URL || process.env?.REACT_APP_OKTA_LOGOUT_REDIRECT_URL,
  ALLOCATION_SERVICE_BASE_URL:  window._env_?.REACT_APP_ALLOCATION_SERVICE_BASE_URL || process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL,
  SUPPLY_ACTUALS_SERVICE_BASE_URL:  window._env_?.REACT_APP_SUPPLY_ACTUALS_SERVICE_BASE_URL || process.env?.REACT_APP_SUPPLY_ACTUALS_SERVICE_BASE_URL,
  LANDING_NOTIFICATIONS_BASE_URL:  window._env_?.REACT_APP_LANDING_NOTIFICATIONS_BASE_URL || process.env?.REACT_APP_LANDING_NOTIFICATIONS_BASE_URL,
  ALLOCATION_SERVICE_BASE_URL_V1:  window._env_?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V1 || process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V1,
  ALLOCATION_SERVICE_BASE_URL_V2:  window._env_?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V2 || process.env?.REACT_APP_ALLOCATION_SERVICE_BASE_URL_V2,
}